window.addEventListener('load', event => {
    let shareButtons = document.querySelectorAll('[data-toggle-share]');

    for (let button of shareButtons) {
        let lock = 0;
        button.addEventListener('click', (event) => {
            event.preventDefault();

            if (!lock) {
                lock = 1;
                let shareValue = button.dataset.toggleShare;
                let shareText = button.dataset.shareText;

                const shareData = {
                    title: 'Home Group',
                    text: shareText,
                    url: shareValue
                };

                if (navigator.canShare) {
                    navigator.share(shareData);
                    lock = 0;
                } else {
                    //no native share
                    navigator.clipboard.writeText(shareValue);
                    button.classList.add('active');

                    setTimeout(() => {
                        button.classList.remove('active');
                        lock = 0;
                    }, 2000);
                }
            }

        });
    }
});